module.exports = __webpack_public_path__ + "img/model_d.239c69f2.png";